import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import Main from "./Main";
import { useEffect } from "react";
import { initializeTagManager } from "shared/utility/GoogleTagManagerUtility";
import { BrowserRouter } from "react-router-dom";
import ToastNotificationContainer from "components/common/ToastNotification";
import { getConfiguration } from "shared/utility/ConfigUtility";

function App() {
  
  useEffect(() => {
    const addGoogleTagManager = getConfiguration("addGoogleTagManager");

    if (addGoogleTagManager === true) {
      initializeTagManager();
    }
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Main />
        <ToastNotificationContainer />
      </BrowserRouter>
    </div>
  );
}

export default App;
